export default [
  {
    name: 'Sheeba',
    breed: 'collie',
    gender: 'female',
    age: 7,
    color: 'black/white',
    weight: 34,
    location: 'fourside',
    notes: 'Pure breed. Trained for competitions.'
  },
  {
    name: 'Hillary',
    breed: 'mut',
    gender: 'female',
    age: 17,
    color: 'orange/white',
    weight: 37,
    location: 'threed',
    notes: 'Super friendly'
  },
  {
    name: 'Zeus',
    breed: 'afghan hound',
    gender: 'male',
    age: 9,
    color: 'gray',
    weight: 68,
    location: 'threed',
    notes: 'Super friendly'
  },
  {
    name: 'Katie',
    breed: 'golden retriever',
    gender: 'female',
    age: 2,
    color: 'black',
    weight: 44,
    location: 'threed',
    notes: 'Super friendly'
  }
]
